import { useEffect } from 'react';
import { startAiProductDescriptionGeneration } from '@/services/aiProductDescription';
import { useCanvasStateManager } from '@/stores/canvasStateManager';
import { usePublishStore } from '@/stores/publishStore';

/**
 * Auto-start the AI suggestion once per design when the products step mounts.
 *
 * Fires only from `idle`, so a second visit to the step (or React StrictMode's
 * double mount) never starts another run and never overwrites what the seller
 * has typed meanwhile. Every further run is the seller's click on
 * "Neu vorschlagen" in the Publish step. Designs without a decorated position
 * are skipped; the run starts on the next visit once a design exists.
 */
export function useAiProductDescription() {
  useEffect(() => {
    if (usePublishStore.getState().aiGenerationStatus !== 'idle') return;
    if (
      useCanvasStateManager.getState().getPositionsWithDesigns().length === 0
    ) {
      return;
    }

    void startAiProductDescriptionGeneration();
  }, []);
}
